<template>
    <div id="news-page" class="clp page filter-category-menu news-category-page">
        <NewsCategoryMenu />
        <div v-if="getDataSuccess">
            <section class="news-category-list__content" v-if="currentCategoryByDate.length > 0">
                <div class="news__year-content" v-for="newsYear in currentCategoryByDate" :key="newsYear.year">
                    <div class="news__year-innercontent" v-if="newsYear.year == lastYear || showAll || parseInt(currentCategoryId) === 27">
                        <h3 v-if="newsYear.year != currentYear">{{newsYear.year}}</h3>
                        <div class="news-category__row-outer">
                            <div class="news-category__row" v-for="(month, index) in newsYear.months" :key="index">
                                <div class="container-xl">
                                    <h4>{{ getMonthName(month.monthName)}}</h4>
                                    <div class=" row" v-if="parseInt(currentCategoryId) !== 27">
                                        <div class="col-12 col-md-4 col-lg-3 news-item-wrap" v-for="news in month.news" :key="news.id">
                                            <div class="news-item-innerwrap">
                                                <NewsItem  
                                                    :name="news.name"
                                                    :date="dateFormatted(news.published_date)"
                                                    :id="news.id"                                  
                                                    :news_slug="news.slug"
                                                    :short_description="news.short_description"
                                                />
                                            </div>                                       
                                        </div>
                                    </div>  
                                    <!-- Reklálfilmek -->
                                    <div class="row" v-else>
                                        <div class="col-12 col-md-6 news-item-wrap" v-for="news in month.news" :key="news.id">
                                            <div v-if="news.youtube_id != '' | news.youtube_id != null || news.youtube_id != undefined" class="news-item-innerwrap">
                                                <NewsItemYoutube  
                                                    :name="news.name"
                                                    :id="news.id"                                  
                                                    :news_slug="news.slug"
                                                    :youtube_id="news.youtube_id"
                                                    :srcset="itemSrcset(news)" 
                                                    :src="itemSrc(news, 'w1120h620')"
                                                    :srcsizes="'(max-width: 767px) 740px, 560px'"
                                                />
                                            </div>
                                        </div>
                                    </div> 
                                </div>               
                            </div> 
                        </div>
                    </div>                           
                </div>
                <div class="container-xl" v-if="( currentCategoryByDate.length > 1 || !hasCurrentYearContent) && parseInt(currentCategoryId) !== 27 ">
                    <div class="row">                        
                        <div class="col-12 btn-wrap">
                            <div class="btn btn--primary" @click.stop="toggleYearsContent()">
                                <span>{{lang('Mutasd_a_tavalyi_bejegyzeseket')}}</span></div>
                        </div>
                    </div>
                </div>     
            </section>
            <div v-else class="no-result">
                <div class="container-xl">
                    <p>{{lang('nincs_talalat')}}</p>    
                </div>                
            </div>
        </div>
        <div v-else>        
            <Loading />              
        </div>
    </div>
</template>

<script>
import NewsCategoryMenu from '@/components/pagesComponents/news/NewsCategoryMenu.vue'
import axios from 'axios'
import NewsItem from '@/components/pagesComponents/news/NewsItem.vue'
import NewsItemYoutube from '@/components/pagesComponents/news/NewsItemYoutube.vue'
import Loading from '@/components/layoutComponents/Loading.vue'

export default {
    data(){
        return {
            currentCategoryNews: [],
            currentCategoryName: '',
            currentCategoryId: '',
            getDataSuccess: false,
            currentCategoryByDate: [],
            showAll:false,
            monthNames: [
                {id: 1, name: this.lang('aktualis_honap_1')},
                {id: 2, name: this.lang('aktualis_honap_2')},
                {id: 3, name: this.lang('aktualis_honap_3')},
                {id: 4, name: this.lang('aktualis_honap_4')},
                {id: 5, name: this.lang('aktualis_honap_5')},
                {id: 6, name: this.lang('aktualis_honap_6')},
                {id: 7, name: this.lang('aktualis_honap_7')},
                {id: 8, name: this.lang('aktualis_honap_8')},
                {id: 9, name: this.lang('aktualis_honap_9')},
                {id: 10, name: this.lang('aktualis_honap_10')},
                {id: 11, name: this.lang('aktualis_honap_11')},
                {id: 12, name: this.lang('aktualis_honap_12')}
            ],
            currentCategoryMetas: {
                meta_description: null,
                meta_image: null,
                meta_keywords: null,
                meta_title: null
            },
            hasCurrentYearContent: false
        }
    },
    components:{
        NewsCategoryMenu,
        NewsItem,
        NewsItemYoutube,
        Loading
    },
     computed:{
        NewsCategory(){
            return this.$store.getters.getNewsCategory;             
        },  
        currentNewsCatSlug(){
            return this.$route.params.news_category_slug;
        }, 
        currentYear(){
            var d = new Date();            
            return  d.getFullYear();
        },  
        lastYear(){               
            let _this = this 
            
            if (_this.currentCategoryByDate.length > 0){
                return _this.currentCategoryByDate[0].year                                    
            } else {
                return null
            }
        }     
    },
    watch:{     
        NewsCategory: function() {            
            this.currentCategoryByDate = [] 
            this.currentCategoryId = ''                          
            this.getNews(); 
        },         
        $route: function(){             
            this.getDataSuccess = false
            this.currentCategoryByDate = [] 
            this.currentCategoryId = ''   
            this.showAll = false
            this.getNews();           
        }                    
    },
    methods:{
        getNews(){
            let currentRouteName = this.$route.name.substring(0, this.$route.name.indexOf('_'))

            if ( currentRouteName == 'NewsAll'){
                this.getAllNews()
            } else {
                if (this.NewsCategory.length > 0) {
                    this.getActualNewsList()
                }
                
            }
        },
        getActualNewsList(){            
            let _this = this
            let currentCategorySlug = this.currentNewsCatSlug;
            let currentCategoryId = null;
            let currentCategoryName = null;            

            this.NewsCategory.filter(item => {                
                if (item.slug == currentCategorySlug){
                    currentCategoryId = item.category_id,
                    currentCategoryName = item.name
                }
            })                                  
            
            this.currentCategoryId = currentCategoryId;
            
            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/category/' + currentCategoryId + '?relations=1&relations_params[information][where][0][0]=where&relations_params[information][where][0][1]=status&relations_params[information][where][0][2]=1&relations_params[information][order_by][0][0]=published_date&relations_params[information][order_by][0][1]=desc&relations_params[information][order_by][1][0]=name&relations_params[information][order_by][1][1]=asc',{            
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {
                
                if (response.data.status == true ){                    
                    if (response.data.category[0].information){                        

                        //this.currentCategoryNews = response.data.category[0].information;
                         this.currentCategoryNews = [];
                             if (_this.$store.state.needPD){
                                for (var i=0; i <response.data.category[0].information.length ;i++)
                                {
                                    if (response.data.category[0].information[i].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                                          this.currentCategoryNews.push(response.data.category[0].information[i]);
                                }
                                
                            }
                            else
                                this.currentCategoryNews = response.data.category[0].information;
                        this.currentCategoryName = currentCategoryName;
                        this.selectByDate()  
                        this.getDataSuccess = true

                        if (response.data.category[0].meta_description != ''){
                            _this.currentCategoryMetas.meta_description = response.data.category[0].meta_description
                        } else {
                            _this.currentCategoryMetas.meta_description = null
                        }                       

                        if ( !response.data.category[0].meta_image ) {  
                            _this.currentCategoryMetas.meta_image = null
                        } else {
                            let meta_image_src = process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME + '/' + response.data.category[0].meta_image.path + response.data.category[0].meta_image.file_name
                            _this.currentCategoryMetas.meta_image = meta_image_src
                        }
                        
                        if (response.data.category[0].meta_keywords != ''){
                            _this.currentCategoryMetas.meta_keywords = response.data.category[0].meta_keywords
                        } else {
                            _this.currentCategoryMetas.meta_keywords = null
                        }
                        
                        if (response.data.category[0].meta_title != '') {
                            _this.currentCategoryMetas.meta_title = response.data.category[0].meta_title
                        } else {
                            _this.currentCategoryMetas.meta_title = null
                        }          
                        
                        _this.setCurrentMetaTags() 
                    } else {
                        this.currentCategoryNews = []
                        this.getDataSuccess = true
                    }
                    
                } else {
                    this.currentCategoryNews = []
                    this.getDataSuccess = true                    
                }                                                              
            })
            .catch((err) => {
                console.log(err)
            });             
        },  
        getAllNews(){
            let _this = this

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/information?relations=1&where[0][0]=where&where[0][1]=type&where[0][2]=news&where[1][0]=where&where[1][1]=status&where[1][2]=1&order_by[0][0]=published_date&order_by[0][1]=desc&order_by[1][0]=name&order_by[1][1]=asc',{            
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {
                
                if (response.data.status == true ){
                    if (response.data.information){
                        //this.currentCategoryNews = response.data.information; 
                         this.currentCategoryNews = [];
                             if (_this.$store.state.needPD){
                                for (var i=0; i <response.data.information.length ;i++)
                                {
                                    if (response.data.information[i].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                                          this.currentCategoryNews.push(response.data.information[i]);
                                }
                                
                            }
                            else
                                this.currentCategoryNews = response.data.information;
                        this.getDataSuccess = true  
                        this.selectByDate()                     
                    } else {
                        this.currentCategoryNews = []
                        this.getDataSuccess = true
                    }

                    //set META TAGS                    
                    _this.setMetaTags({
                        title: _this.lang("title_aktualis_osszes"), 
                        desc: _this.lang('meta_description_aktualis'), 
                        keywords: _this.lang('meta_keywords_aktualis'), 
                        ogType: 'article', 
                        ogTitle: _this.lang("title_aktualis_osszes"),
                        ogImage: null, 
                        ogImageWidth: null, 
                        ogImageHeight: null, 
                        ogDesc: _this.lang('meta_description_aktualis')
                    })  
                    
                } else {
                    this.currentCategoryNews = []
                    this.getDataSuccess = true                    
                }                                                              
            })
            .catch((err) => {
                console.log(err)
            }); 
        },
        dateFormatted(dateString){
            let date =  dateString.slice(0,10)      
            let formattedDate = date.replace(/-/g, ".");       
            return formattedDate
        },
        getDateFormat(date){
            let dateTillDays =  date.slice(0,10)            
            let d = dateTillDays.replace(/-/g, "");             
            let dY = parseInt(d.slice(0,4));
            let dM = parseInt(d.slice(4,6));
            let dD = parseInt(d.slice(6));            

            let dateFormat = new Date (dY, dM - 1, dD);                                
            return dateFormat;
        },
        selectByDate(){
            let _this = this;            
            var list = this.currentCategoryNews
            var selectedArrayNews = []  
            
            this.currentCategoryByDate = []

            list.forEach(element => {
                let itemDate = _this.getDateFormat(element.published_date);
                let itemYear = itemDate.getFullYear();
                let itemMonth = itemDate.getMonth() + 1;                                            
                
                var yearIndex = selectedArrayNews.findIndex(x => parseInt(x.year) == parseInt(itemYear));

                if (yearIndex > -1){
                    //van ilyen év             
                    let monthIndex =  selectedArrayNews[yearIndex].months.findIndex( y => parseInt(y.monthName) === parseInt(itemMonth))
                    
                    if (monthIndex > -1){
                        //van ilyen hónap
                        selectedArrayNews[yearIndex].months[monthIndex].news.push(element) 
                    } else {
                        //nincs még ilyen hónap
                        selectedArrayNews[yearIndex].months.push({
                            monthName: itemMonth,
                            news: [element]
                        }) 
                    }                    

                } else {
                    //nincs ilyen év még
                    selectedArrayNews.push( {
                        year: itemYear,
                        months: [{
                            monthName: itemMonth,
                            news: [element]
                        }]
                    })
                }                                  
            });  
                                                            
            this.currentCategoryByDate = selectedArrayNews;            

            if (this.currentCategoryByDate.find( item => parseInt(item.year) === parseInt(_this.currentYear) )) {
                _this.hasCurrentYearContent = true
            } else {
                _this.hasCurrentYearContent = false
            }
        },   
        getMonthName(montId){
            return this.monthNames.find( x => x.id == montId).name
        },
        toggleYearsContent(){            
            let clickedItem = event.target            
            this.showAll = !this.showAll
                        
            if ( this.showAll === true) {
                if (clickedItem.classList.contains("btn--primary")){
                    clickedItem.childNodes[0].innerHTML = this.lang('Mutasd_a_tavalyi_bejegyzeseket__elrejt')
                    clickedItem.classList.add("opened");
                } else {
                    clickedItem.innerHTML = this.lang('Mutasd_a_tavalyi_bejegyzeseket__elrejt')
                    clickedItem.parentNode.classList.add("opened");
                }
                
            } else {
                if (clickedItem.classList.contains("btn--primary")){
                    clickedItem.childNodes[0].innerHTML = this.lang('Mutasd_a_tavalyi_bejegyzeseket')
                    clickedItem.classList.remove("opened");
                } else {
                    clickedItem.innerHTML = this.lang('Mutasd_a_tavalyi_bejegyzeseket')
                    clickedItem.parentNode.classList.remove("opened");
                }
               
            }                        
        },
        setCurrentMetaTags(){
            let _this = this            

            this.setMetaTags({
                title: _this.currentCategoryMetas.meta_title, 
                desc: _this.currentCategoryMetas.meta_description, 
                keywords: _this.currentCategoryMetas.meta_keywords, 
                ogType: 'article', 
                ogTitle: _this.currentCategoryMetas.meta_title,
                ogImage: _this.currentCategoryMetas.meta_image, 
                ogImageWidth: null, 
                ogImageHeight: null, 
                ogDesc: _this.currentCategoryMetas.meta_description
            })
        }       
    } ,
    created(){
        // this.NewsCategory = this.$store.getters.getNewsCategory;
        this.getNews();           
    }    
}
</script>